import {Vrs} from './vrs'
import {makeAutoObservable} from "mobx"
import {authStore} from "../store";
import {Cms} from "./cms";
import {Vda} from "./vda";
import {Ums} from "./ums";
import {Sea} from "./sea";
import {Sls} from "./sls";
import {Pms} from "./pms";
import {Fms} from "./fms";
import {Vhs} from "./vhs";
import {Kpi} from "./kpi";
import {Sca} from "./sca";
import {Sts} from "./sts";

export * from './utils'
export * from './utilsVhs'
export * from './enumDisplayMapper'

export * from './vrs'

interface ApiError { data: any; statusText: string }

export interface ApiErrorMessage {
    title?: string,
    message: string
}

export function extractMessage(error: ApiError | undefined) : ApiErrorMessage | undefined {
    const data = error?.data
    let title = error?.statusText
    if (!data && !title) {
        return undefined
    }
    let message = ''
    if (data) {
        if (data.error) {
            title = data.error
        }
        if (typeof data === 'string') {
            message = data as any as string
        } else if (data.message) {
            message = data.message as any as string
        } else {
            message = JSON.stringify(data)
        }
    }

    return {
        title,
        message
    }
}

class ApiStatus {
    constructor() {
        makeAutoObservable(this)
    }

    private num = 0
    private _apiError: ApiError | undefined

    public increment() {
        this.num++
    }

    public decrement() {
        if (this.num > 0) {
            this.num--
        }
    }

    get loading(): boolean {
        return this.num !== 0
    }

    addError(param: ApiError) {
        this._apiError = param
    }

    get error(): ApiError | undefined {
        return this._apiError
    }

    clearErrors() {
        this._apiError = undefined
    }
}

const apiStatus = new ApiStatus()

const customFetch = async (...fetchParams: Parameters<typeof fetch>) => {
    apiStatus.increment()
    if (fetchParams.length >1 && authStore.accessToken) {
        const params = fetchParams.at(1) as any
        if(params.headers) {
            params.headers['Authorization'] = `Bearer ${authStore.accessToken}`
        }
    }
    try {
        return await fetch(...fetchParams)
    } catch (e) {
        throw e
    } finally {
        apiStatus.decrement()
    }
};

export type ApiName = 'VRS' | 'CMS' | 'VDA' | 'UMS' | 'SEA' | 'SLS' | 'PMS' | 'FMS' | 'VHS' | 'KPI' | 'SCA' | 'STS'

function getConfigForApi(name: ApiName) {
    const propName = `REACT_APP_${name}_API_BASE_URL`
    const baseUrl = process.env[propName]
    return {
        customFetch: customFetch,
            baseUrl
    }
}


const api = {
    vrs: new Vrs(getConfigForApi('VRS')),
    cms: new Cms(getConfigForApi('CMS')),
    vda: new Vda(getConfigForApi('VDA')),
    ums: new Ums(getConfigForApi('UMS')),
    sea: new Sea(getConfigForApi('SEA')),
    sls: new Sls(getConfigForApi('SLS')),
    pms: new Pms(getConfigForApi('PMS')),
    fms: new Fms(getConfigForApi('FMS')),
    vhs: new Vhs(getConfigForApi('VHS')),
    kpi: new Kpi(getConfigForApi('KPI')),
    sca: new Sca(getConfigForApi('SCA')),
    sts: new Sts(getConfigForApi('STS')),
}

export {
    getConfigForApi,
    apiStatus,
    api
}
